export default __webpack_public_path__ + "static/media/ic-schedule-off.691856b2.svg";